import { useAlarmStore } from '@/store/alarm'
import { useAlarmProfileStore } from '@/store/alarmProfile'
import { useAnomalyDetectorStore } from '@/store/anomaly_detector'
import { useCompanyDashboardStore } from '@/store/companyDashboard'
import { useDashboardStore } from '@/store/dashboard'
import { useFareOptimizerStore } from '@/store/fareOptimizer'
import { useGroupStore } from '@/store/group'
import { useMaintenanceStore } from '@/store/maintenance'
import { useRateStore } from '@/store/rate'
import { useRegisterStore } from '@/store/register'
import { useReportStore } from '@/store/report'
import { useSensorStore } from '@/store/sensor'

export function clearAllStores() {
  const allStores = [
    () => useGroupStore(),
    () => useSensorStore(),
    () => useDashboardStore(),
    () => useFareOptimizerStore(),
    () => useRegisterStore(),
    () => useReportStore(),
    () => useAlarmStore(),
    () => useRateStore(),
    () => useAlarmProfileStore(),
    () => useAnomalyDetectorStore(),
    () => useCompanyDashboardStore(),
    () => useMaintenanceStore(),
  ]

  allStores.forEach((storeFn) => {
    const instance = storeFn()
    if (instance.$reset) {
      instance.$reset()
    }
  })
}
